import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

type MonthFormat = 'M' | 'MM' | 'MMM' | 'MMMM' | 'MMMMM';

@Pipe({
  name: 'month'
})
export class MonthPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(month: number, format: MonthFormat = 'M'): string {
    const date = new Date();
    date.setMonth(month);
    return this.datePipe.transform(date, format) || '';
  }

}
